import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 進度條
import 'nprogress/nprogress.css' // Progress 進度條樣式
import {
  Message
} from 'element-ui'
import {
  getAuth
} from '@/utils/auth' // 驗權

let loadAsyncRouter = false
const whiteList = ['/login'] // 不重定向白名單
router.beforeEach((to, from, next) => {
  localStorage.setItem('routerBefore', from.path)
  NProgress.start()
  /** 請求頭包含授權資訊 並且 頁面必須授權 直接進入 */
  if (getAuth()) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done()
    } else {
      if (!loadAsyncRouter) { // 判斷目前使用者是否獲取許可權
        loadAsyncRouter = true
        if (store.getters.allAuth) {
          store.dispatch('GenerateRoutes', store.getters.allAuth).then(() => { // 根據auths許可權產生可訪問的路由表
            router.addRoutes(store.getters.addRouters) // 動態新增可訪問路由表
            if (to.path === '/404') {
              next({
                path: to.redirectedFrom || '/',
                replace: true
              })
            } else {
              next({
                ...to,
                replace: true
              })
            }
          })
        } else {
          store.dispatch('getAuth').then(res => { // 拉取user_info
            const auths = res.data
            store.dispatch('GenerateRoutes', auths).then(() => { // 根據auths許可權產生可訪問的路由表
              router.addRoutes(store.getters.addRouters) // 動態新增可訪問路由表
              if (to.path === '/404') {
                next({
                  path: to.redirectedFrom || '/',
                  replace: true
                })
              } else {
                next({
                  ...to,
                  replace: true
                })
              }
            })
          }).catch((err) => {
            loadAsyncRouter = false
            store.dispatch('LogOut').then(() => {
              Message.error(err.error || '獲取使用者資訊失敗')
              next({
                path: '/'
              })
            })
          })
        }
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否則全部重定向到登錄頁
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 結束Progress
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})
